// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.tenant.LeasingTenantWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant,
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path,
  LeasingTenantWebApiHandler_getTenantInfo,
  LeasingTenantWebApiHandler_getTenantInfo_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetPaginatedLeasesForTenantWebApiResponseDto,
  GetTenantInfoWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetPaginatedLeasesForTenantParams {
  numResults: number;
  offset: number;
}

export type LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Options = UseQueryOptions<
  GetPaginatedLeasesForTenantWebApiResponseDto,
  unknown,
  GetPaginatedLeasesForTenantWebApiResponseDto,
  Array<string | GetPaginatedLeasesForTenantParams>
>;

const LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey = (
  getParams: GetPaginatedLeasesForTenantParams,
) => [LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Path, getParams];

/**
 * get paginated leases for tenant
 */
export const useLeasingTenantWebApiHandler_getPaginatedLeasesForTenant = (
  getParams: GetPaginatedLeasesForTenantParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey(getParams),
    queryFn: () => LeasingTenantWebApiHandler_getPaginatedLeasesForTenant(getParams, httpClient),
  });
};
useLeasingTenantWebApiHandler_getPaginatedLeasesForTenant.getKey =
  LeasingTenantWebApiHandler_getPaginatedLeasesForTenant_GetKey;

export type LeasingTenantWebApiHandler_getTenantInfo_Options = UseQueryOptions<
  GetTenantInfoWebApiResponseDto,
  unknown,
  GetTenantInfoWebApiResponseDto,
  Array<string>
>;

const LeasingTenantWebApiHandler_getTenantInfo_GetKey = () => [LeasingTenantWebApiHandler_getTenantInfo_Path];

/**
 * get tenant information
 */
export const useLeasingTenantWebApiHandler_getTenantInfo = ({
  httpClient,
  ...options
}: Omit<LeasingTenantWebApiHandler_getTenantInfo_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingTenantWebApiHandler_getTenantInfo_GetKey(),
    queryFn: () => LeasingTenantWebApiHandler_getTenantInfo(httpClient),
  });
};
useLeasingTenantWebApiHandler_getTenantInfo.getKey = LeasingTenantWebApiHandler_getTenantInfo_GetKey;
